<template>
	<div class="container-fluid">
		<div class="alert alert-danger m-1" v-show="errors != null">
			<div class="row d-flex justify-content-center align-items-center">
				<div class="col-12 col-sm-12 col-md-3 text-center h5" v-for="(item,index) in errors">
					{{item}}
				</div>
			</div>
		</div>
		<div class="row d-flex justify-content-center align-items-center mt-2">
			<div class="col-12">
				<div class="row d-flex justify-content-center align-items-center">
					<div class="col-6 col-sm-6 col-md-2 text-center">
						<div class="mui-checkbox">
						    <label>
						      <input type="checkbox" v-model="manager.aktiv">
						      Aktív kezelő
						    </label>
						</div>
					</div>
					<div class="col-6 col-sm-6 col-md-2">
						<div class="mui-textfield mui-textfield">
					    	<input type="number" v-model="manager.regio">
					    	<label>Régiókód</label>
					  	</div>
					</div>
					<div class="col-6 col-sm-6 col-md-2">
						<div class="mui-textfield mui-textfield">
					    	<input type="number" v-model="manager.regio_max">
					    	<label>Régiókód -ig</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="manager.nev">
					    	<label>Név</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="manager.varos">
					    	<label>Város</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="manager.email">
					    	<label>E-mail cím</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-4">
				    	<div class="mui-select">
							<select v-model="manager.tipus">
								<option
									v-for="(v,k) in managerTypes"
									:key="k"
									:value="v.value"
								>
									{{ v.text }}
								</option>
							</select>
							<label>
								Kezelő típus
							</label>
						</div>
					</div>
				</div>

				<div
					class="row d-flex justify-content-center align-items-center mt-2"
					v-if="!change"
				>
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="manager.loginnev">
					    	<label>Belépési név</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="manager.pass_new">
					    	<label>Jelszó</label>
					  	</div>
					</div>
				</div>

				<div
					class="row d-flex justify-content-center align-items-center mt-2"
					v-if="change&&isAdmin"
				>
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="manager.loginnev">
					    	<label>Belépési név</label>
					  	</div>
					</div>
					<div class="col-12 col-sm-6 col-md-4">
						<div class="mui-textfield mui-textfield">
					    	<input type="text" v-model="newpass">
					    	<label>Új jelszó</label>
					  	</div>
					</div>
				</div>

				
				<div class="row d-flex justify-content-center">
					<div class="col-10">
						<div class="mui-textfield">
						    <textarea v-model="manager.megj"></textarea>
						    <label>Megjegyzés</label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="m-2">
			<div class="row d-flex justify-content-center">
				<dir class="col text-center">
					<button class="btn btn-success btn-lg" @click.prevent="save">
						<span v-show="change">Mentés</span>
						<span v-show="!change">Hozzáad</span>
					</button>
				</dir>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment'
export default {
	name: 'manager_data',
	props:['change','id','user'],
	data() {
		return {
			manager: {},
			errors: null,
			newpass: ''
	    }
	},
	mounted(){
	    if(this.change) {
	    	this.$Progress.start()
	    	this.req.post('/managers/getdata',{
	    		azon: this.id
	    	})
	    		.then(res => {
	    			this.manager = res.data.manager
	    			this.$Progress.finish()
	    		})
	    		.catch(err => {
	    			console.log(err)
	    			this.$Progress.fail()
	    		})
	    }
	},
	methods: {
		save(){
			this.$Progress.start()
			this.errors = null
	    	this.req.post('/managers/save',{
	    		manager: this.manager,
	    		user: this.user,
	    		change: this.change,
	    		newpass: this.newpass,
	    		admin: this.isAdmin
	    	})
	    		.then(res => {
	    			if(res.data.status === `error`) {
	    				this.errors = res.data.errors
	    			} else {
	    				toastr.success(`${this.change?'Mentés':'Hozzáadás'} sikeres`)
	    			}
	    			this.$Progress.finish()
	    			this.$router.push('/managers')
	    		})
	    		.catch(err => {
	    			this.$Progress.fail()
	    		})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/managers/manager_data.vue